import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private message = new BehaviorSubject('default message');
  portMessage = this.message.asObservable();

  constructor() { }
  deliverMsg(message: any) {
   // console.log(message)
    this.message.next(message)
  }
}
